module.exports = __webpack_public_path__ + "effe-uno.png?ddc7b87868d176e5cabfa23192dc36a7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/partner/effe-uno.png
// module id = 125
// module chunks = 0